/** Значение ширины документа для отрисовки на стороне сервера  */
export const DEFAULT_DOCUMENT_WIDTH = 1024;

/** Значение высоты документа для отрисовки на стороне сервера  */
export const DEFAULT_DOCUMENT_HEIGHT = 768;

/** Ключ localStorage с коллекциями для публикации в ленту  */
export const PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY = 'promoteShowInFeedCollections';

export const CHECKOUT_BUTTON_TEXT = 'Купить в 1 клик';
